import { RecentSearch } from '@/core/graphql/generated/types';
import { generateQueryString } from '@/utils/url/generateQueryString';

export const buildRecentSearchQueryString = (
	payload: RecentSearch['payload']
) => {
	if (payload.__typename === 'HCPSearchAndFiltersType') {
		const {
			searchString,
			countries,
			states,
			specialtyGroups,
			specialties,
			hcpTypes,
			hcos,
			includeInactive
		} = payload;

		const params = {
			...(searchString && { name: searchString }),
			...(countries && { country: countries }),
			...(states && { state: states }),
			...(specialtyGroups && {
				specialtyGroup: specialtyGroups
			}),
			...(specialties && { specialty: specialties }),
			...(hcpTypes && { hcpType: hcpTypes }),
			...(hcos && { hco: hcos }),
			...(includeInactive && { includeInactive })
		};

		return generateQueryString(params);
	}

	if (payload.__typename === 'HCOSearchAndFiltersType') {
		const { searchString, countries, states, hcoTypes, includeInactive } =
			payload;

		const params = {
			...(searchString && { name: searchString }),
			...(countries && { country: countries }),
			...(states && { state: states }),
			...(hcoTypes && { hcoType: hcoTypes }),
			...(includeInactive && { includeInactive })
		};

		return generateQueryString(params);
	}

	return '';
};
